/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from './svg-icon';

export const LinearAddIcon = ({ color = 'white', ...props }) => (
  <SvgIcon {...props} viewBox="0 0 24 24" color={color}>
    <path
      d="M6 12H18"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18V6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

LinearAddIcon.propTypes = {
  color: PropTypes.string,
};

LinearAddIcon.defaultProps = {
  color: 'white',
};
